import { combineReducers } from "redux";
import { all } from "redux-saga/effects";

import * as auth from "../app/Modules/Auth/_redux/authRedux";
import { categorySlice } from "../app/Modules/Categories/_redux/category/categorySlice";
import { newCategorySlice } from "../app/NewRedux/Categories/categorySlice";
import { homepageTabSlice } from "../app/NewRedux/HomePageTabs/homepageTabSlice";
import { assetClassSlice } from "../app/Pages/AssetClass/_redux/assetClassSlice";
import { assetSlice } from "../app/Pages/Assets/_redux/assetSlice";
import { extendTimerReqSlice } from "../app/Pages/Assets/extendTimerReq/_redux/extendTimerReqSlice";
import { notesSlice } from "../app/Pages/Assets/pages/AssetDetail/NotesTab/_redux/notesSlice";
import { negotiationSlice } from "../app/Pages/Assets/underNegotiation/_redux/negotiationSlice";
import { buyerAssetSlice } from "../app/Pages/Buying/_redux/buyerAssetSlice";
import { wantToBuySlice } from "../app/Pages/Buying/wantToBuy/_redux/wantToBuySlice";
import { dashboardSlice } from "../app/Pages/Dashboard/_redux/dashboardSlice";
import { employeeSlice } from "../app/Pages/Employees/_redux/employeeSlice";
import { inspectiionSlice } from "../app/Pages/Inspection/_redux/inspectiionSlice";
import { locationSlice } from "../app/Pages/Locations/_redux/locationSlice";
import { makeSlice } from "../app/Pages/Make/_redux/makeSlice";
import { badgeSlice } from "../app/Pages/MasterData/badge/_redux/badgeSlice";
import { businessTypeSlice } from "../app/Pages/MasterData/businessTypes/_redux/businessTypeSlice";
import { companyTypeSlice } from "../app/Pages/MasterData/companyTypes/_redux/companyTypeSlice";
import { financePartnerSlice } from "../app/Pages/MasterData/financePartner/_redux/financePartnerSlice";
import { gSettingSlice } from "../app/Pages/MasterData/globalSetting/_redux/gSettingSlice";
import { partnerSlice } from "../app/Pages/MasterData/logisticPartner/_redux/partnerSlice";
import { typeSlice } from "../app/Pages/MasterData/logisticType/_redux/typeSlice";
import { serviceSlice } from "../app/Pages/MasterData/serviceOffered/_redux/serviceSlice";
import { subscriptionSlice } from "../app/Pages/MasterData/subscription/_redux/subscriptionSlice";
import { modelSlice } from "../app/Pages/Model/_redux/modelSlice";
import { buyerSellerSlice } from "../app/Pages/Organizations/_redux/buyerSeller/buyerSellerSlice";
import { organizationsSlice } from "../app/Pages/Organizations/_redux/organizations/organizationsSlice";
import { rolesSlice } from "../app/Pages/RolesAndPermissions/_redux/rolesSlice";
import { savedCardSlice } from "../app/Pages/SavedCards/_redux/savedcardSlice";
import { finCompanySlice } from "../app/Pages/Services/FInanceCompanyDetail/_redux/finCompanySlice";
import { transportCompanySlice } from "../app/Pages/Services/TransportCompanyDetail/_redux/transportCompanySlice";

import { layoutSlice } from "./layout/layoutSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  category: categorySlice.reducer,
  location: locationSlice.reducer,
  assets: assetSlice.reducer,
  organizations: organizationsSlice.reducer,
  buyerSeller: buyerSellerSlice.reducer,
  employee: employeeSlice.reducer,
  finCompany: finCompanySlice.reducer,
  transportCompany: transportCompanySlice.reducer,
  dashboard: dashboardSlice.reducer,
  make: makeSlice.reducer,
  model: modelSlice.reducer,
  negotiation: negotiationSlice.reducer,
  wantToBuy: wantToBuySlice.reducer,
  roles: rolesSlice.reducer,
  inspection: inspectiionSlice.reducer,
  assetClass: assetClassSlice.reducer,
  buyerAsset: buyerAssetSlice.reducer,
  gSettings: gSettingSlice.reducer,
  notes: notesSlice.reducer,
  subscription: subscriptionSlice.reducer,
  partner: partnerSlice.reducer,
  seriveOffered: serviceSlice.reducer,
  financepartner: financePartnerSlice.reducer,
  logistictype: typeSlice.reducer,
  businessType: businessTypeSlice.reducer,
  companyType: companyTypeSlice.reducer,
  badge: badgeSlice.reducer,
  extendTimerReq: extendTimerReqSlice.reducer,
  savedCards: savedCardSlice.reducer,
  layout: layoutSlice.reducer,
  //New reducers start here
  newCategory: newCategorySlice.reducer,
  homepageTabSlice: homepageTabSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
